<template>
  <svg width="12" height="10" viewBox="0 0 12 10"  xmlns="http://www.w3.org/2000/svg">
    <path
        d="M12 2.35714V8.14286C12 8.48385 11.8645 8.81088 11.6234 9.05199C11.3823 9.29311 11.0553 9.42857 10.7143 9.42857H1.28571C0.944722 9.42857 0.617695 9.29311 0.376577 9.05199C0.135459 8.81088 0 8.48385 0 8.14286V1.28571C0 0.944722 0.135459 0.617695 0.376577 0.376577C0.617695 0.135459 0.944722 0 1.28571 0H3.42857C3.76109 0.000213123 4.08059 0.129243 4.32 0.36L5.05714 1.07143H10.7143C11.0553 1.07143 11.3823 1.20689 11.6234 1.44801C11.8645 1.68912 12 2.01615 12 2.35714Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconPen"
}
</script>

<style scoped>

</style>